let env = {};

env.baseURL = 'https://api.dds-digital-homolog.innovareti.com.br/api/v1/';
env.normalURL = 'https://api.dds-digital-homolog.innovareti.com.br/';

export default env



// WEBPACK FOOTER //
// ./src/config/env.js